// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-docs-ww-js": () => import("./../src/pages/docs-ww.js" /* webpackChunkName: "component---src-pages-docs-ww-js" */),
  "component---src-pages-docs-js": () => import("./../src/pages/docs.js" /* webpackChunkName: "component---src-pages-docs-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

